<template>
  <div class="message" :class="isScroll?'':'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div v-if="messageCon" class="messageDetail">
          <span>{{ messageCon.title }}</span>
          <time>{{ new Date((messageCon.validFrom).replace(/-/g, "/")).format("Y-MM-dd") }}</time>
          <div class="item" v-html="messageCon.content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/message.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import '@/utils/tradeDataUtil'
export default {
  name: 'MessageDetail',
  components: { Header },
  data() {
    return {
      title: '消息中心',
      rightContent: 'isNo',
      id: this.$route.query.id || '',
      isScroll: '',
      messageCon: ''
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    this.noticeDetail()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    noticeDetail() {
      api.getNoticeDetail(this.id).then(res => {
        if (res.data.code == 200) {
          this.messageCon = res.data.data.notice
        }
      })
    }
  }
}
</script>
